import { useState } from "react";

import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

// OpenLayers
import OlMap from "ol/Map";
import Layer from "ol/layer/Layer";

// Tools
import { getBaseLayers, getVisibleBaseLayerCodes } from "lib/utilities/map";
import { updateURLParameter } from "lib/utilities/misc";
import { assetURL } from "lib/utilities/asset";

// Interfaces
import MapToolMode from "lib/enums/maptoolmode";

const BaseLayerPicker = new Popup({
	title: () => getLocaleString("baselayers"),
	distinct: true,
	render: function() {
		const map:OlMap = this.get("map");
		const [currentBaseLayerCode, setCurrentBaseLayerCode] = useState<string>(getVisibleBaseLayerCodes(map)[0]);
			
		const selectBaseLayer = (layer:Layer) => {
			const selectAction:Function = this.get("select-action");
			
			selectAction(layer);
			setCurrentBaseLayerCode(getVisibleBaseLayerCodes(map)[0]);
			
			setTimeout(() => _ui.closePopupOf(this), 100);
		}
		const drawBaseLayerList = () => {
			const layers:Layer[] = getBaseLayers(map);
			const rows = [];
			
			for(let i in layers) {
				const layer:Layer = layers[i];
				const lconfig:any = layer.get("config");
				const checked:boolean = currentBaseLayerCode == layer.get("code");
				const className:string = `layer-group__layer${checked ? ` layer-group__layer--selected ${_ui.getSelClassName()}` : ""}`;
				const size:number = 40;
				
				let url:string = lconfig.image;
				
				url = updateURLParameter(url, "width", size.toString());
				url = updateURLParameter(url, "height", size.toString());
				
				rows.push(
					<div className={className} onClick={() => selectBaseLayer(layer)} key={i}>
						<div className="layer-row__meta">
							<div className="layer-row__image layer-row__image--baselayer">
								<img src={url} /> 
							</div>
							<div className="layer-row__title">
								{lconfig.name}
							</div>
						</div>
					</div>
				);
			}
			
			return rows;
		}
		
		return (
			<>
				{drawBaseLayerList()}
			</>
		)
	}
});

export default BaseLayerPicker;